export default __webpack_public_path__ + "554dbf85e7b088fa9434561447e82eb4.otf";